/* eslint-disable eqeqeq */
import { Box, Button, Flex, FormLabel, Heading, Input } from "@chakra-ui/react";
import { useFormik } from "formik";
import * as Yup from "yup";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ForgetpasswordAction } from "../../../modules/auth/Actions";
import PublicLayout from "../../public/Layout/layout";
const ForgetpasswordForm = ({ withTitle }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoading = useSelector((state) => state.auth.isLoading);

  const forgetpasswordSchema = Yup.object().shape({
    phone: Yup.string().required("Required"),
  });
  const formik = useFormik({
    initialValues: {},
    validationSchema: forgetpasswordSchema,
    validateOnChange: true,
    onSubmit: (values) => {
      dispatch(ForgetpasswordAction(values));
    },
  });

  const errorStyle = (isValid) =>
    isValid == "Required" ? "red !important" : "#0100108 !important";
  return (
    <PublicLayout color="main_1" bg="white" register={true}>
      <Flex
        bg="whiteAlpha.700"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        my="150px"
        w="100%"
        h="100%"
        dir="rtl"
      >
        <div style={{ width: "40%" }}>
          <div style={{ width: "100%" }}>
            <form onSubmit={formik.handleSubmit}>
              <Flex
                flexDirection="column"
                w="100%"
                gap={8}
                fontFamily="sans-serif"
              >
                {withTitle && (
                  <Heading textAlign={"center"} mb="10px">
                    Forget Password
                  </Heading>
                )}
                <Box w="100%" mt="10px !important">
                  <Flex alignItems={"center"}>
                    <FormLabel
                      htmlFor="phone"
                      className="form-label "
                      color="main_1"
                      fontSize="22px"
                      fontWeight="500"
                    >
                      رقم الهاتف <span style={{ color: "red" }}>*</span>
                    </FormLabel>
                  </Flex>

                  <Input
                    style={{
                      width: "100%",
                      padding: "12px",
                      objectFit: "contain",
                      borderRadius: "10px",
                      boxShadow: "inset 0 0 16px 0 rgba(0, 0, 0, 0.16)",
                      border: "1px solid",
                      backgroundColor: "#fff",
                    }}
                    name="phone"
                    borderColor={errorStyle(formik?.errors.phone)}
                    size="lg"
                    onChange={formik.handleChange}
                    value={formik.values.phone}
                  />
                </Box>

                <Button
                  type="submit"
                  w="250px"
                  p="22px"
                  alignSelf={"center"}
                  isLoading={isLoading}
                  bg="main_1"
                  color="white"
                >
                  حفظ
                </Button>
              </Flex>
            </form>
          </div>
        </div>
      </Flex>
    </PublicLayout>
  );
};

export default ForgetpasswordForm;
